import React from 'react';
import { GridApi } from 'ag-grid-community';
import { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface PaginationProps {
  api: GridApi;
}

const Pagination: FC<PaginationProps> = ({ api }) => {
  const [totalPageNumber, setTotalPageNumber] = useState(0);

  const getCurrentPage = () => {
    return api.paginationGetCurrentPage() + 1;
  };
  const [pageNumber, setPageNumber] = useState(getCurrentPage());
  const { t } = useTranslation();

  api.addEventListener('paginationChanged', () => {
    const totalPageCount = api.paginationGetTotalPages();
    setTotalPageNumber(totalPageCount);
  });

  const onFirstPageClick = () => {
    api.paginationGoToFirstPage();
    setPageNumber(getCurrentPage());
  };
  const onLastPageClick = () => {
    api.paginationGoToLastPage();
    setPageNumber(getCurrentPage());
  };
  const onNextPageClick = () => {
    api.paginationGoToNextPage();
    setPageNumber(getCurrentPage());
  };
  const onPreviousPageClick = () => {
    api.paginationGoToPreviousPage();
    setPageNumber(getCurrentPage());
  };
  const onPageNumberChange: React.ChangeEventHandler<HTMLInputElement> = (
    e
  ) => {
    const pageNum = Number(e.target.value);
    const agGridPageNumber = pageNum - 1;
    api.paginationGoToPage(agGridPageNumber);
    setPageNumber(pageNum);
  };

  return (
    <div className="ag-grid-pagination">
      <span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onFirstPageClick()}
          disabled={pageNumber == 1}
        >
          <i className="icon fas fa-chevron-double-left"></i>
        </button>
      </span>
      <span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onPreviousPageClick()}
          disabled={pageNumber == 1}
        >
          <i className="icon fas fa-chevron-left"></i>
        </button>
      </span>
      <div className="page-count">
        <span className="page"> {t('product.productList.page')}</span>
        <div className="page-jump">
          <input
            type="number"
            min="1"
            className="form-control"
            value={pageNumber}
            onChange={onPageNumberChange}
          />
        </div>
        {t('product.productList.of')}{' '}
        <input
          className="page-total"
          type="text"
          value={totalPageNumber}
          readOnly={true}
        ></input>
      </div>
      <span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onNextPageClick()}
          disabled={pageNumber == totalPageNumber}
        >
          <i className="icon fas fa-chevron-right"></i>
        </button>
      </span>
      <span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onLastPageClick()}
          disabled={pageNumber == totalPageNumber}
        >
          <i className="icon fas fa-chevron-double-right"></i>
        </button>
      </span>
    </div>
  );
};

export default Pagination;
